<template>
  <div>
    <div class="info-wrapper">
      <div class="banner">
        <div class="cover">
          <div class="cover-text">
            <div class="main">{{ $t("xwzx") }}</div>
          </div>
        </div>
      </div>
      <div class="main-container">
        <div class="title">
          <h4>{{ title }}</h4>
          <div class="sub">{{ dateTime }}</div>
        </div>
        <div class="content" v-html="content"></div>
        <div class="check-btn-group">
          <div class="prev btn" @click="checkPrev">上一篇 <i></i></div>
          <div class="next btn" @click="checkNext"><i></i>下一篇</div>
        </div>
      </div>
    </div>
    <OwFooter />
  </div>
</template>
<script>
import axios from "axios";
import OwFooter from "@/components/ow-footer";
import { formatDate } from "@/utils";
export default {
  name: "news-center",
  components: {
    OwFooter
  },
  data() {
    return {
      title: "",
      dateTime: "",
      content: "",
      prevObj: "",
      nextObj: ""
    };
  },
  watch: {
    $route: {
      handler(val) {
        // 获取json数据
        this.getJson();
        // 获取资讯内容
        this.getContent();
      }
    }
  },
  created() {
    // 获取json数据
    this.getJson();
    // 获取资讯内容
    this.getContent();
    // 获取css
    this.getCss();
  },
  methods: {
    getJson() {
      const id = this.$route.query.newsId;
      const type = this.$route.query.type;
      axios.get(`/fs-sm/push/info.json`).then(response => {
        let data = response.data;
        data = data.filter(item => item.infoType == type);
        data.forEach((item, index) => {
          if (item.infoId == id) {
            this.title = item.title;
            this.dateTime = formatDate(item.crtTime, "yyyy-MM-dd");
            if (index == 0) {
              this.prevObj = data[data.length - 1];
            } else {
              this.prevObj = data[index - 1];
            }
            if (index == data.length - 1) {
              this.nextObj = data[0];
            } else {
              this.nextObj = data[index + 1];
            }
          }
        });
      });
    },
    getContent() {
      const id = this.$route.query.newsId;
      axios.get(`/fs-sm/push/html/${id}.html`).then(response => {
        this.content = response.data;
      });
    },
    getCss() {
      axios.get(`/fs-sm/push/html/style.css`).then(response => {
        let style = document.createElement("style");
        style.setAttribute("type", "text/css");
        style.innerHTML = response.data;
        let head = document.querySelector("head");
        head.appendChild(style);
      });
    },
    // 查看上一篇
    checkPrev() {
      this.$router.push({
        path: "/news-Info",
        query: { newsId: this.prevObj.infoId, type: this.prevObj.infoType }
      });
    },
    checkNext() {
      this.$router.push({
        path: "/news-Info",
        query: { newsId: this.nextObj.infoId, type: this.nextObj.infoType }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.cover {
  position: relative;
  width: 100%;
  height: 30rem;
  min-height: 30rem;
  overflow: hidden;
  background: url("~@/assets/images/newsCenter/banner.png") no-repeat top;
  background-size: cover;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      180deg,
      #030f21 0%,
      rgba(3, 15, 33, 0.9) 12%,
      rgba(4, 9, 20, 0.2) 63%,
      rgba(3, 14, 32, 0.7) 91%,
      #030f21 100%
    );
  }
}
.cover-text {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  color: #fff;
  text-align: center;
  transform: translate(-50%, -50%);

  .main {
    font-size: 2.1rem;
    font-weight: bold;
    color: #ffffff;
    letter-spacing: 2px;
  }
}
.info-wrapper {
  .main-container {
    .title {
      width: 60rem;
      margin: 0 auto 1.5rem;
      padding-bottom: 1.5rem;
      border-bottom: 1px solid #e6e6e6;
    }
    h4 {
      margin: 6rem 0 1rem;
      font-size: 1.6rem;
      font-weight: bold;
      color: #333333;
      text-align: center;
    }
    .sub {
      font-size: 0.7rem;
      color: #999999;
      text-align: center;
    }
    .content {
      width: 45rem;
      margin: 0 auto;
      overflow: hidden;
      p {
        font-size: 0.9rem;
        font-weight: bold;
        color: #333333;
        line-height: 1.8rem;
        text-indent: 2em;
        text-align: justify;
      }
      img {
        width: 100%;
        margin: 1.6rem 0;
      }
      ul {
        li {
          font-size: 0.9rem;
          font-weight: bold;
          color: #333333;
          line-height: 1.8rem;
          text-indent: 2em;
        }
      }
    }
    .check-btn-group {
      margin-top: 1.5rem;
      padding-top: 1.5rem;
      width: 60rem;
      margin: 0 auto 2rem;
      text-align: right;
      border-top: 1px solid #e6e6e6;
      .btn {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        &:hover {
          color: #2f61ae;
        }
        i {
          display: inline-block;
          width: 0.7rem;
          height: 0.7rem;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        &.prev {
          margin-right: 2.4rem;
          i {
            background-image: url("~@/assets/images/newsCenter/ico_prev.png");
          }
        }
        &.next {
          i {
            background-image: url("~@/assets/images/newsCenter/ico_next.png");
          }
        }
      }
    }
  }
}
</style>
